import React from 'react';
// import WithSidebar from "../../templates/withSidebar";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";

import Search from './components/search';
import Content from './components/content';
import SearchVocProvider from './searchContext';

const VocCurrentReport = () => {
  const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.VOC_CURRENT
  );
  return (
    // <SearchVocProvider>
    //   <WithSidebar>
        <div>
          <Search />
          <Content roleUser= {roleUser}/>
        </div>
    //   </WithSidebar>
    // </SearchVocProvider>
  );
};

export default VocCurrentReport;